import { FileRepository } from ".";
import { IFileRegistry, IFileRepository } from "../../domain/file";

export class FileRegistry implements IFileRegistry {
  constructor(getToken: () => string) {
    this._repository = new FileRepository(getToken);
  }

  private readonly _repository: IFileRepository;

  getFileRepository(): IFileRepository {
    return this._repository;
  }
}
